import { render, staticRenderFns } from "./StatementConvoRemove.vue?vue&type=template&id=b61dd714&"
import script from "./StatementConvoRemove.vue?vue&type=script&lang=js&"
export * from "./StatementConvoRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports